import React from 'react';
const BoolInput = (props) => {
    const { orgMetadataField, onChange, isRequired, hasRequiredError, val } = props;
    return (React.createElement("div", { className: 'form-input-group' },
        React.createElement("label", { className: 'input-label', htmlFor: orgMetadataField.name },
            orgMetadataField.name,
            " ",
            isRequired ? '*' : ''),
        React.createElement("div", { className: 'radios' },
            React.createElement("span", { className: 'input-container' },
                React.createElement("input", { type: 'radio', id: `${orgMetadataField.name}-yes`, "data-testid": `test-input-${orgMetadataField.name}-yes`, className: 'input radio', name: orgMetadataField.name, checked: val === true, onChange: () => onChange(orgMetadataField.name, true) }),
                React.createElement("label", { className: 'input-label', htmlFor: `${orgMetadataField.name}-yes` }, "Yes"),
                "\u00A0\u00A0\u00A0",
                React.createElement("input", { type: 'radio', id: `${orgMetadataField.name}-no`, "data-testid": `test-input-${orgMetadataField.name}-no`, className: 'input radio', name: orgMetadataField.name, checked: val === false, onChange: () => onChange(orgMetadataField.name, false) }),
                React.createElement("label", { className: 'input-label', htmlFor: `${orgMetadataField.name}-no` }, "No"))),
        isRequired && hasRequiredError &&
            React.createElement("span", { className: 'required-error' }, "Required")));
};
export default BoolInput;
